import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, withRouter } from "react-router-dom";

import {
  Container,
  Wrapper,
  Title,
  Bold,
  Copy,
  Spinner,
  InternalImage
} from "app/NativeComponents/common";
import { Loading } from "app/NativeComponents/website/common";
import { loadSignUpOnboarding, getUser, appRedirect } from "app/NativeActions";
import Login from "app/DealMachineCore/components/Login";

class AffiliateLoginContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onboarding_content: null,
      onboarding_content_loading: true
    };
  }

  componentDidMount() {
    const token = window.localStorage.getItem("token");
    if (token != null) {
      this.props.getUser({
        token,
        device: this.props.device,
        redirect: true
      });
    }

    loadSignUpOnboarding()
      .then(data => {
        if (data && data.items && data.items.length > 0) {
          this.setState(() => ({
            onboarding_content: data.items[0]
              ? data.items[0].fields
                ? data.items[0].fields
                : null
              : null,
            onboarding_content_loading: false
          }));
        }
        this.setState(() => ({ onboarding_content_loading: false }));
      })
      .catch(err => {
        this.setState(() => ({ onboarding_content_loading: false }));
      });
  }

  renderTitle() {
    const { onboarding_content } = this.state;
    const { colors } = this.props;

    if (onboarding_content && onboarding_content.sidebarTitle) {
      return (
        <Title
          style={{
            color: colors.white_text_color,
            textAlign: "center"
          }}
        >
          {onboarding_content.sidebarTitle}
        </Title>
      );
    }
  }

  renderTitleBold() {
    const { onboarding_content } = this.state;
    const { colors } = this.props;

    if (onboarding_content && onboarding_content.sidebarTitleBold) {
      return (
        <Title
          style={{
            color: colors.white_text_color,
            textAlign: "center"
          }}
        >
          <Bold>{onboarding_content.sidebarTitleBold}</Bold>
        </Title>
      );
    }
  }

  renderDescription() {
    const { onboarding_content } = this.state;
    const { colors } = this.props;

    if (onboarding_content && onboarding_content.sidebarText) {
      return (
        <Copy
          style={{
            color: colors.white_text_color,
            textAlign: "center"
          }}
        >
          {onboarding_content.sidebarText}
        </Copy>
      );
    }
  }

  renderBold() {
    const { onboarding_content } = this.state;
    const { colors } = this.props;

    if (onboarding_content && onboarding_content.sidebarBold) {
      return (
        <Copy
          style={{
            color: colors.white_text_color,
            textAlign: "center"
          }}
        >
          <Bold>{onboarding_content.sidebarBold}</Bold>
        </Copy>
      );
    }
  }

  renderIcon() {
    if (this.props.isMobile && this.props.device === "desktop") {
      return (
        <Wrapper
          style={{
            padding: 40,
            paddingBottom: 0,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <InternalImage
            style={{
              width: 60,
              objectFit: "contain",
              alignItems: "center",
              justifyContent: "flex-start"
            }}
            contain
            image={"/assets/images/Icon-blue.png"}
          />
        </Wrapper>
      );
    }
  }

  renderContainer() {
    if (this.props.init && this.props.user) {
    } else if (this.props.loading) {
      return <Spinner />;
    } else {
      return (
        <div id="deal-signup-container">
          {this.renderIcon()}
          <Wrapper
            style={{
              padding: 20,
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Title style={{ textAlign: "center" }}>
              Log in to your affiliate account
            </Title>
          </Wrapper>
          <Login />
        </div>
      );
    }
  }

  render() {
    return (
      <div className="dm-app-wrapper">
        <div id="deal-sign-up-sidebar">
          <InternalImage
            style={{
              marginBottom: 0,
              width: 100,
              marginLeft: 0,

              objectFit: "contain",
              alignItems: "center",
              justifyContent: "flex-start"
            }}
            contain
            image={"/assets/images/Icon-white.png"}
          />

          <Wrapper>
            {this.renderTitle()}
            {this.renderTitleBold()}
            {this.renderDescription()}
            {this.renderBold()}
          </Wrapper>

          <div />
        </div>
        {this.renderContainer()}
      </div>
    );
  }
}

const mapStateToProps = ({ auth, settings, native }) => {
  const { token, user, init, loading } = auth;

  const { colors } = settings;
  const { isMobile, device } = native;

  return {
    token,
    user,
    init,
    loading,
    colors,
    isMobile,
    device
  };
};

export default withRouter(
  connect(mapStateToProps, { getUser, appRedirect })(AffiliateLoginContainer)
);
